import React, { useEffect, useState } from 'react'
import BASEURL from '../../Config/global';
import { ShareIcon, crossIcon, MinusIconEmpty, PauseButton, PlayButton } from '../../Assets/svg';
import axios from 'axios';
import MainLayout from '../../Layout/MainLayout';
import { clearAllSound, playAudio, playSound, checkSoundPlayerOrMixes, playMyMixes, playMyMixer, removeMix, playMyMixerObj } from '../../Store/Slices/SoundPlayerSlice';
import { useDispatch, useSelector } from 'react-redux';
import './style.css';
import { useNavigate } from 'react-router';
import ShareMixSave from '../../Components/ShareMixSave/ShareMixSave';
import { Modal } from 'react-bootstrap';
import { pauseMixer, playMixer, resetMixer } from '../../Store/Slices/MixerSlice';
import { ClearMyMix, ClearExternalMixData, PauseMixer, PauseMyMixer, PlayMixer, PlayMyMix, PlayMyMixId } from '../../Store/Slices/MyMixerSlice';
import { Howl, Howler } from "howler";
import { activeUser, userLogout } from '../../Store/Slices/APIs';
import Common from '../../Util/common';
import { setMixSavedId, setSharingTracks } from '../../Store/Slices/SaveMixSlice';
import MyMixStrip from './MyMixStrip';
import { useTranslation } from 'react-i18next';
import { translateEnglishToSpanishBatch } from '../../Util/translator';

const MyMixes = () => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const [myMixList, setMyMixList] = useState([]);
    const [playFilteredlist, setplayFilteredlist] = useState([]);
    const [soundlist, setSoundlist] = useState([]);
    const [isShareMixSaveShow, setIsShareMixSaveShow] = useState(false);
    const [saveShareMixId, setSaveShareMixId] = useState(0);
    const [isShareMixSaveName, setIsShareMixSaveName] = useState('');

    const [deleteMixerModal, setDeleteMixerModal] = useState(false);
    const [deleteMixerId, setDeleteMixerId] = useState(false);
    const [succesModal, setSuccesModal] = useState(false);

    const [messageShow, setMessageShow] = useState(false);
    const userPrompts = useSelector((state) => state.user.userPrompts);


    const [isOpenShareMixModal, setIsOpenShareMixModal] = useState(false);


    // const [playingMixAudio, setPlayingMixAudio] = useState([]);
    // 11/9/2023

    useEffect(() => {
        dispatch(userLogout())
        playlistData();
    }, [])

    const playlistData = async () => {
        try {
            const response = await axios.get(`${BASEURL}/api/sounds/sounds_mixture`);
            if (!response.data.error) {
                const serverData = response?.data?.data || [];
                const namesOfMixes = serverData.map((item) => item.name) || [];

                if (i18n?.language === 'es' && namesOfMixes.length > 0) {
                    try {
                        const translateResult = await translateEnglishToSpanishBatch(namesOfMixes);
                        if (translateResult.success && Array.isArray(translateResult.translatedTexts)) {
                            const translatedTexts = translateResult.translatedTexts;
                            const translatedData = serverData.map((item, idx) => ({
                                ...item,
                                // prefer translated name when available
                                name: translatedTexts[idx] || item.name
                            }));
                            makeFilteredData(translatedData);
                            return;
                        }
                    } catch (err) {
                        console.error('Batch translation failed', err);
                    }
                }

                makeFilteredData(serverData);
            }
        } catch (error) {
            console.error(error);
        }
    }

    const makeFilteredData = (data) => {
        let filteredData = []
        data.filter((item) => {
            filteredData.push(item)
        })
        // const reverseArray = [...filteredData].reverse();
        setMyMixList(filteredData)
    }

    const deleteShareMixSaveLink = (id) => {
        // console.log(playFilteredlist)
        let filteredData = [];
        playFilteredlist.length > 0 && playFilteredlist.filter((item) => {
            if (item.id !== id) {
                filteredData.push(item);
            }
        })

        setplayFilteredlist(filteredData);
        setSuccesModal(true);
        setDeleteMixerModal(false);


        //delete api call
        const deletePlaylist = async () => {
            try {
                const response = await axios.delete(`${BASEURL}/api/sounds/sounds_mixture/${id}`);
                if (!response.data.error) {
                    setTimeout(() => {
                        setSuccesModal(false);
                    }, 500);
                }
            } catch (error) {
                console.error(error);
            }
        }
        deletePlaylist();
    }

    const closeWindow = () => {
        document.body.classList.remove('overflow-hidden');
        setIsShareMixSaveShow(false);
    }

    const openShareMixModal = () => {
        setIsOpenShareMixModal(true);
    }

    const closeShareMixModal = () => {
        dispatch(setMixSavedId(null));
        dispatch(setSharingTracks({ item: [] }))
        setIsOpenShareMixModal(false);
    }

    const deleteMyMix = async (id) => {
        try {
            setSuccesModal(true);
            let filteredData = [];
            myMixList?.length > 0 && myMixList?.filter((item) => {
                if (item.id !== id) {
                    filteredData.push(item);
                }
            })
            setMyMixList(filteredData);
            const response = await axios.delete(`${BASEURL}/api/sounds/sounds_mixture/${id}`);
            if (!response.data.error) {
                setTimeout(() => {
                    setSuccesModal(false);
                }, 500);
            }
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <>
            <MainLayout>
                <div className='playlist-layout'>
                    <div className="col-12">
                        <h1 className="pageTitle my-sm-3 mt-3 mb-0 pb-3">{t("mixes.myMixes")}</h1>
                    </div>
                    {myMixList.map((item, index) => (<MyMixStrip item={item} key={index} openShareMixModal={openShareMixModal} deleteMyMix={deleteMyMix} />))}
                </div>


                {/* Share Mixer Modal */}
                <Modal
                    show={isShareMixSaveShow}
                    centered
                    className="mixer-modal"
                    backdrop="static"
                >
                    <Modal.Body>
                        <ShareMixSave handleClick={closeWindow} soundlist={soundlist} isSaveList={true} id={saveShareMixId} shareMixName={isShareMixSaveName} />
                    </Modal.Body>
                </Modal>

                {/* delete modal */}
                <Modal
                    show={deleteMixerModal}
                    centered
                    className="soundModal"
                    backdrop="static"
                >
                    <Modal.Body>
                        <div className="text-end">
                            <button
                                className="closeButton notButton ms-auto"
                                onClick={() => setDeleteMixerModal(false)}
                            >
                                <img src={crossIcon} alt="" />
                            </button>
                        </div>
                        <div className="customModalContent my-5">
                            <h2 className="font-16 lh-16 fw-normal mb-5 text-center">{userPrompts?.delete_mix}</h2>
                            <div className="mt-4 d-flex align-items-center justify-content-center">
                                <button style={{ backgroundColor: '#ffffff1f' }} className='mx-3 px-5 py-2 fs-6 fw-light text-white text-capitalize btn rounded-pill d-flex align-items-center justify-content-center flex-shrink-0' onClick={() => deleteShareMixSaveLink(deleteMixerId)}>
                                    <span className=''>{t("playlists.yes")}</span>
                                </button>
                                <button style={{ backgroundColor: '#ffffff1f' }} className='mx-3 px-5 py-2 fs-6 fw-light text-white text-capitalize btn rounded-pill d-flex align-items-center justify-content-center flex-shrink-0' onClick={() => setDeleteMixerModal(false)}>
                                    <span className=''>{t("playlists.no")}</span>
                                </button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                {/* success modal */}
                <Modal
                    show={succesModal}
                    centered
                    className="success-modal"
                    backdrop="static"
                >
                    <Modal.Body>
                        <div className="p-5">
                            <h2 className="font-16 lh-16 my-5 fw-normal text-center">{userPrompts?.delete_mix_nofitication}</h2>
                        </div>
                    </Modal.Body>
                </Modal>

                {/* success modal */}
                <Modal
                    show={messageShow}
                    centered
                    className="success-modal"
                    backdrop="static"
                >
                    <Modal.Body>
                        <div className="px-3 py-2 flex-grow-1 w-100">
                            <div className="text-end">
                                <button
                                    className="closeButton notButton ms-auto"
                                    onClick={() => setMessageShow(false)}
                                >
                                    <img src={crossIcon} alt="" />
                                </button>
                            </div>
                            <h2 className="font-16 lh-16 my-5 fw-normal text-center mt-5 pt-4">This save mix is no longer exist, <br /> please create a new one</h2>
                        </div>
                    </Modal.Body>
                </Modal>
            </MainLayout>
        </>
    )
}

export default MyMixes;